import { GridToolbar, GridToolbarContainer } from "@mui/x-data-grid";

import { DateSelection } from "@/components/Filter/dateSelection";
import { SaveFilterAndSearch } from "@/components/Filter/saveFilterAndSearch";

import ProductAutoComplete from "@/components/Filter/productAutocomplete";
import { setSelectedProduct, setTypeGrouping } from "@/features/dataTableSlice";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useDispatch, useSelector } from "react-redux";
export default function ProfitAndLossToolBar(props) {
  const { productSelecter, fetchData, loading, productData } = props;
  const dispatch = useDispatch();
  const typeGrouping = useSelector((state) => state.dataTable.typeGrouping);
  const combineSameSku = useSelector((state) => state.dataTable.combineSameSku);

  const selectedProduct = useSelector(
    (state) => state.dataTable.selectedProduct
  );
  return (
    <>
      <GridToolbarContainer>
        {productSelecter && (
          <Box>
            <FormControl sx={{ m: 1, width: 400 }}>
              <ProductAutoComplete
                multiple
                fullWidth
                id={"product-auto-0"}
                selectByCategory
                productOptions={productData}
                handleOnChange={(value) => {
                  dispatch(setSelectedProduct({ value: value }));
                }}
                selectedValue={selectedProduct}
                error={selectedProduct.length <= 0}
              ></ProductAutoComplete>
            </FormControl>
            <DateSelection></DateSelection>
            <FormControl sx={{ m: 1, width: 100 }}>
              <InputLabel id="group-by-label">分類</InputLabel>
              <Select
                value={typeGrouping}
                labelId="group-by-label"
                label="brand"
                onChange={(event) => {
                  dispatch(setTypeGrouping({ value: event.target.value }));
                }}
              >
                <MenuItem value={"product"}>產品</MenuItem>
                <MenuItem value={"brand"}>品牌</MenuItem>
              </Select>
            </FormControl>
            <SaveFilterAndSearch
              fetchData={fetchData}
              loading={loading}
              combineSameSku={combineSameSku}
              page={"profitAndLoss"}
            />
          </Box>
        )}
      </GridToolbarContainer>
      <GridToolbarContainer>
        <GridToolbar
          csvOptions={{
            utf8WithBom: true,
          }}
        />
      </GridToolbarContainer>
    </>
  );
}
